import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../components/DynamicSkeleton"

const columnConfig = {
  Details: { content: <Skeleton height="70px" width="220px" />, center: false },
  "Battery Capacity(kW/h)": {
    content: <Skeleton height="20px" width="100px" />,
    center: true,
  },
  "Battery Voltage(v)": {
    content: <Skeleton height="20px" width="100px" />,
    center: true,
  },
  Connectors: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="40px" width="40px" />
        <Skeleton height="40px" width="40px" />
      </div>
    ),
    center: true,
  },
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const VehicleSkeleton = ({ infiniteScroll, rows = 6 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default VehicleSkeleton
